import { SvgIcon } from '@material-ui/core'

export function CloseIcon({ viewBox = '0 0 14 14', ...props }) {
  return (
    <SvgIcon viewBox={viewBox} style={{ width: 15, height: 15 }} {...props}>
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
